<template>

  <div class="federation-link">
    <div class="name" v-if="federation" @click="toggleDetails" title="More details">{{ federation.alias || federation.name }}</div>
    <div class="empty" v-else>-</div>
  </div>

</template>

<script>

import Popup from '@/components/Popup'

export default {
  name: 'FederationLink',
  components: {
    Popup
  },
  props: ['id'],
  computed: {
    federation () {
      return this.$store.state.federations[this.id]
    }
  },
  methods: {
    toggleDetails () {
      this.$router.push(`/federations/${this.id}`)
    }
  },
  mounted () {
    if (this.id && !this.$store.state.federations[this.id]) {
      this.$store.dispatch('getFederation', this.id)
    }
  }
}

</script>

<style lang="scss" scoped>

  .name {
    display: inline;
    cursor: pointer;
    &:hover {
      color: #555;
    }
  }

  .id {
    display: inline;
    color: gray;
    margin-left: 20px;
  }

  .empty {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/links/Federation.vue